import { css } from 'styled-components';
import token from 'styled-token';
import { spaceMixin } from '../spaceMixin';

/** @class PropertyCardPhotoHeaderMixin */
/** @method */
/**
 * Using `height: 0` and no vertical padding to allow as much of the photo to be clickable as
 * possible (CDS-1777)
 */
export var PropertyCardPhotoHeaderMixin = function PropertyCardPhotoHeaderMixin(props) {
  return token({
    gap: 'PropertyCard.photo.header.gap',
    marginTop: 'PropertyCard.photo.header.marginTop',
    paddingX: 'PropertyCard.photo.header.padding.X',
    paddingY: 'PropertyCard.photo.header.padding.Y'
  }, function (_ref) {
    var gap = _ref.gap,
      marginTop = _ref.marginTop,
      paddingX = _ref.paddingX,
      _ref$paddingY = _ref.paddingY,
      paddingY = _ref$paddingY === void 0 ? 0 : _ref$paddingY;
    return css(["grid-area:photo-top;height:0;margin-top:", ";padding:", ";z-index:1;display:grid;grid-auto-flow:column;grid-gap:", ";justify-content:space-between;"], marginTop ? marginTop + "px" : spaceMixin('xs')(props), paddingX && paddingY ? paddingY + "px " + paddingX + "px" : "0 " + spaceMixin('xs')(props), gap ? gap + "px" : spaceMixin('sm')(props));
  })(props);
};